import { PRINCIPLES } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

export const Principles = () => (
  <section
    data-testid="principles-section"
    className="relative bg-linen py-16 md:py-20"
  >
    <div className="mx-auto max-w-shell px-6 md:px-10">
      <Reveal>
        <div className="label-xs text-slate">Our standard</div>
      </Reveal>

      <Reveal delay={0.06}>
        <dl className="mt-10 grid gap-y-10 gap-x-8 sm:grid-cols-2 lg:grid-cols-5">
          {PRINCIPLES.map((p, i) => (
            <div
              key={p.title}
              data-testid={`principle-${i}`}
              className={`lg:px-6 ${
                i !== 0 ? "lg:border-l lg:border-obsidian/12" : "lg:pl-0"
              }`}
            >
              <dt className="label text-obsidian">{p.title}</dt>
              <dd className="mt-4 space-y-1">
                {p.lines.map((l) => (
                  <p key={l} className="text-[0.8rem] text-slate leading-snug">
                    {l}
                  </p>
                ))}
              </dd>
            </div>
          ))}
        </dl>
      </Reveal>
    </div>
  </section>
);

export default Principles;
